<template>
    <button @click="requestToggleFollowingState" class="btn btn-follow"
            :class="btnClass">
        <span v-if="isFollowed" class="fas fa-check"></span><span>Follow<span v-if="isFollowed">ing</span></span>
    </button>
</template>

<script>

    import axios from 'axios';

    const api = axios.create({
        baseURL: '/followings',
        params: {
            format: 'json'
        }
    });

    export default {
        name: 'FollowButton',
        data() {
            return {
                isFollowed: false
            }
        },
        props: {
            following: {
                type: Boolean,
                required: true
            },
            followableId: {
                type: Number,
                required: true
            },
            followableType: {
                type: String,
                validator(val) {
                    return ['question', 'discussion', 'member'].includes(val)
                },
                required: true
            }
        },
        methods: {
            requestToggleFollowingState: function () {
                if (!Grabcad.authenticated) {
                    return window.$$loginEventHub.$emit('signInModalTrigger');
                }
                const payload = {
                    [`${this.followableType}_id`]:
                    this.followableId
                };
                this.isFollowed ? this.unfollow(payload) : this.follow(payload);
            },
            follow: function (payload) {
                api.post('', payload)
                    .then(this.toggleFollowingState)
                    .catch(this.handleRequestError);
            },
            unfollow: function (payload) {
                api.delete('', {data: payload})
                    .then(this.toggleFollowingState)
                    .catch(this.handleRequestError);
            },
            toggleFollowingState: function (response) {
                this.isFollowed = !this.isFollowed;
                const data = {
                    count: response.data.follower_count
                };
                data.followable_id = this.followableId;
                this.$eventHub.$emit('followEvent', data);
            },
            handleRequestError: function (err) {
                this.$eventHub.$emit('addAlert', {
                    type: 'error',
                    message: `Failed to follow ${this.followableType}`
                });
                Raygun && Raygun.send(err);
            },
        },
        computed: {
            btnClass() {
                if (this.followableType === 'member') {
                    return {
                        'member-follow': true,
                        'member-follow--followed': this.isFollowed
                    }
                }
                return {'btnGreen__ghost': this.isFollowed};
            }
        },
        mounted() {
            this.isFollowed = this.following;
        }
    }
</script>

<style lang="scss" scoped>
    .member-follow {
        font-weight: bold;
        color: $white;
        background-color: $red;
        border-color: $red-alt;

        &--followed {
            background-color: $green;
            border-color: $green-alt;
        }
    }

    .btn-follow {
        width: 100%;
        display: block;
        text-align: center;
    }
</style>
